import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";

import Consent, { propTypes as consentPropTypes } from './Consent';

const [requested, active, denied] = ['requested', 'given', 'denied'];

function Consents(props) {
  const params = useParams();
  const { t } = useTranslation('account');

  const defaultConsents = useSelector(state => state.consents, shallowEqual);
  const { consents = defaultConsents } = props;

  const categorizedContents = Object.keys(consents).reduce((o, k) => {
    const c = {
      id: k,
      ...consents[k],
    };
    const lastInstance = c.instances[c.instances.length - 1];
    if (lastInstance.denied) {
      o[denied].push(c);
    } else if (lastInstance.given) {
      o[active].push(c);
    } else {
      o[requested].push(c);
    }
    return o;
  }, {
    [requested]: [],
    [active]: [],
    [denied]: [],
  });

  return (
    <section id="consents">
      <h2>{t('consents.heading')}</h2>
      {params.id && (Object.keys(consents).length !== 0)
      ? <Consent id={params.id} {...consents[params.id]} />
      : undefined
      }

      {(!params.id && (Object.keys(consents).length !== 0))
        ? (
          [requested, active, denied].map((category) => {
            if (!categorizedContents[category].length) {
              return undefined;
            }
            return (
              <Fragment key={category}>
                <h3>{t(`consents.subheadings.${category}`)}</h3>
                <ul>
                  {categorizedContents[category].map(c => (
                    <li key={c.id}>
                      <Consent id={c.id} {...c} />
                    </li>
                  ))}
                </ul>
              </Fragment>
            );
          })
        )
        : undefined
      }
      {Object.keys(consents).length === 0
        ? (
          <p>{t('consents.empty')}</p>
        )
        : undefined
      }

    </section>
  );
}

Consents.propTypes = {
  user: PropTypes.object,
  consents: PropTypes.objectOf(PropTypes.shape(consentPropTypes)),
};

export default Consents;
